import Vue from "vue";
import { getLocalStorage, setSessionStorage } from "@/utils/stage";
Vue.prototype.$isEn =
  getLocalStorage("lang") === "en" ||
  window.location.href.indexOf("en-us") > -1 ||
  window.location.href.indexOf("payment.catfantasygame.com") > -1;
Vue.prototype.$isTw =
  getLocalStorage("lang") === "tw" ||
  window.location.href.indexOf("tw") > -1 ||
  window.location.href.indexOf("paymenttw.catfantasygame.com") > -1;
Vue.prototype.$isKr =
  getLocalStorage("lang") === "kr" ||
  window.location.href.indexOf("kr") > -1 ||
  window.location.href.indexOf("paymentkr.catfantasygame.com") > -1;
Vue.prototype.$isJp =
  getLocalStorage("lang") === "jp" ||
  window.location.href.indexOf("jp") > -1 ||
  window.location.href.indexOf("paymentjp.catfantasygame.com") > -1;
Vue.prototype.$isCn =
  getLocalStorage("lang") === "cn" ||
  window.location.href.indexOf("cn") > -1 ||
  window.location.href.indexOf("payment.catfantasygame.com") > -1;

if (
  window.location.href.indexOf("passport-web-pay.17atv.com") > -1 ||
  process.env.NODE_ENV === "development"
) {
  // if(!Vue.prototype.$isKr && !Vue.prototype.$isEn && !Vue.prototype.$isCn) Vue.prototype.$isTw = true // 默认台湾
  // if(!Vue.prototype.$isEn && !Vue.prototype.$isTw && !Vue.prototype.$isCn) Vue.prototype.$isKr = true
  // if(!Vue.prototype.$isKr && !Vue.prototype.$isTw && !Vue.prototype.$isCn) Vue.prototype.$isEn = true
  if (!Vue.prototype.$isKr && !Vue.prototype.$isTw && !Vue.prototype.$isEn)
    Vue.prototype.$isKr = true;
}

// 正式服 项目ID tw46  新马47  kr50
// 测试服 项目ID tw45  新马47  kr51 53jp
Vue.prototype.$projectList = {
  tw: {
    name: "貓之城",
    projectId: 46,
    app_id: "949792f00e554719ef2ee6f6deef0cc5",
    client_game_app_id: "2972947d72960283a623e9cea1aae4da",
    test_projectId: 45,
    test_app_id: "3b0c348056a155bdbf415939a2c2de2c",
    test_client_game_app_id: "b2b2d5a215af171cc8935b1d237e0635",
  },
  kr: {
    name: "캣 판타지",
    projectId: 50,
    app_id: "87c98d10d15a9a460110578ef1061885",
    client_game_app_id: "ceb782c283b0b70c43544a70783d641d",
    test_projectId: 51,
    test_app_id: "d82b2af6056f68976d0bd9c9cf6aea2f",
    test_client_game_app_id: "81d4b4bef73ee1214568d92ccaa6de91",
    // test_projectId: 50,
    // test_app_id: "87c98d10d15a9a460110578ef1061885",
    // test_client_game_app_id: "ceb782c283b0b70c43544a70783d641d",
  },
  en: {
    name: "catfantasy",
    projectId: 45,
    app_id: "27baeca333b1131c32da979cd86dab2c",
    client_game_app_id: "ecc60841370368a7555a9c2edda45f8f",
    test_projectId: 47,
    test_app_id: "aeb578a446b244718c8786ee02905a57",
    test_client_game_app_id: "ae5b63c7f24723428c7ac18f509414d6",
  },
  cn: {
    name: "猫之城",
    projectId: 48,
    app_id: "26a4a635c36dce7a77f945555fc27e70",
    client_game_app_id: "5530bc17df43b8e1627a5528baab520c",
    test_projectId: 52,
    test_app_id: "a24e744d9144c6104dcbd05abe79ac92",
    test_client_game_app_id: "14501f45019b5556cfafbf66cb92b374",
  },
  jp: {
    name: "キャットファンタジー",
    projectId: 51,
    app_id: "93916b6ee1a3b1dd667f05d00eeb995c",
    client_game_app_id: "dec9e0ea06cc75db797fe5f55db45199",
    // test_projectId: 53,
    // test_app_id: "44a9e65a3f2a847f818b59919b456950",
    // test_client_game_app_id: "db1552e5a663b0c3a3cac43a02d52ce7",
    test_projectId: 51,
    test_app_id: "93916b6ee1a3b1dd667f05d00eeb995c",
    test_client_game_app_id: "dec9e0ea06cc75db797fe5f55db45199",
  },
};
let projectId = "";
let client_game_app_id = "";
let app_id = "";
let gameName = "";
if (process.env.NODE_ENV === "production") {
  if (window.location.href.indexOf("passport-web-pay.17atv.com") > -1) {
    if (Vue.prototype.$isEn) {
      setSessionStorage("lang", "en-us");
      app_id = Vue.prototype.$projectList.en.test_app_id;
      projectId = Vue.prototype.$projectList.en.test_projectId;
      client_game_app_id =
        Vue.prototype.$projectList.en.test_client_game_app_id;
      gameName = Vue.prototype.$projectList.en.name;
    } else if (Vue.prototype.$isTw) {
      setSessionStorage("lang", "zh-tw");
      app_id = Vue.prototype.$projectList.tw.test_app_id;
      projectId = Vue.prototype.$projectList.tw.test_projectId;
      client_game_app_id =
        Vue.prototype.$projectList.tw.test_client_game_app_id;
      gameName = Vue.prototype.$projectList.tw.name;
    } else if (Vue.prototype.$isKr) {
      setSessionStorage("lang", "ko-kr");
      app_id = Vue.prototype.$projectList.kr.test_app_id;
      projectId = Vue.prototype.$projectList.kr.test_projectId;
      client_game_app_id =
        Vue.prototype.$projectList.kr.test_client_game_app_id;
      gameName = Vue.prototype.$projectList.kr.name;
    } else if (Vue.prototype.$isJp) {
      setSessionStorage("lang", "ja-jp");
      app_id = Vue.prototype.$projectList.jp.test_app_id;
      projectId = Vue.prototype.$projectList.jp.test_projectId;
      client_game_app_id =
        Vue.prototype.$projectList.jp.test_client_game_app_id;
      gameName = Vue.prototype.$projectList.jp.name;
    } else if (Vue.prototype.$isCn) {
      setSessionStorage("lang", "zh-cn");
      app_id = Vue.prototype.$projectList.cn.test_app_id;
      projectId = Vue.prototype.$projectList.cn.test_projectId;
      client_game_app_id =
        Vue.prototype.$projectList.cn.test_client_game_app_id;
      gameName = Vue.prototype.$projectList.cn.name;
    } else {
      setSessionStorage("lang", "zh-cn");
      app_id = Vue.prototype.$projectList.cn.test_app_id;
      projectId = Vue.prototype.$projectList.cn.test_projectId;
      client_game_app_id =
        Vue.prototype.$projectList.cn.test_client_game_app_id;
      gameName = Vue.prototype.$projectList.cn.name;
    }
  } else {
    if (Vue.prototype.$isEn) {
      setSessionStorage("lang", "en-us");
      app_id = Vue.prototype.$projectList.en.app_id;
      projectId = Vue.prototype.$projectList.en.projectId;
      client_game_app_id = Vue.prototype.$projectList.en.client_game_app_id;
      gameName = Vue.prototype.$projectList.en.name;
    } else if (Vue.prototype.$isTw) {
      setSessionStorage("lang", "zh-tw");
      app_id = Vue.prototype.$projectList.tw.app_id;
      projectId = Vue.prototype.$projectList.tw.projectId;
      client_game_app_id = Vue.prototype.$projectList.tw.client_game_app_id;
      gameName = Vue.prototype.$projectList.tw.name;
    } else if (Vue.prototype.$isKr) {
      setSessionStorage("lang", "ko-kr");
      app_id = Vue.prototype.$projectList.kr.app_id;
      projectId = Vue.prototype.$projectList.kr.projectId;
      client_game_app_id = Vue.prototype.$projectList.kr.client_game_app_id;
      gameName = Vue.prototype.$projectList.kr.name;
    } else if (Vue.prototype.$isCn) {
      setSessionStorage("lang", "zh-cn");
      app_id = Vue.prototype.$projectList.cn.app_id;
      projectId = Vue.prototype.$projectList.cn.projectId;
      client_game_app_id = Vue.prototype.$projectList.cn.client_game_app_id;
      gameName = Vue.prototype.$projectList.cn.name;
    } else if (Vue.prototype.$isJp) {
      setSessionStorage("lang", "ja-jp");
      app_id = Vue.prototype.$projectList.jp.app_id; // 默认isJp
      projectId = Vue.prototype.$projectList.jp.projectId;
      client_game_app_id = Vue.prototype.$projectList.jp.client_game_app_id;
      gameName = Vue.prototype.$projectList.jp.name;
    } else {
      setSessionStorage("lang", "zh-cn");
      app_id = Vue.prototype.$projectList.cn.app_id; // 默认isCn
      projectId = Vue.prototype.$projectList.cn.projectId;
      client_game_app_id = Vue.prototype.$projectList.cn.client_game_app_id;
      gameName = Vue.prototype.$projectList.cn.name;
    }
  }
} else {
  if (Vue.prototype.$isEn) {
    setSessionStorage("lang", "en-us");
    app_id = Vue.prototype.$projectList.en.test_app_id;
    projectId = Vue.prototype.$projectList.en.test_projectId;
    client_game_app_id = Vue.prototype.$projectList.en.test_client_game_app_id;
    gameName = Vue.prototype.$projectList.en.name;
  } else if (Vue.prototype.$isTw) {
    setSessionStorage("lang", "zh-tw");
    app_id = Vue.prototype.$projectList.tw.test_app_id;
    projectId = Vue.prototype.$projectList.tw.test_projectId;
    client_game_app_id = Vue.prototype.$projectList.tw.test_client_game_app_id;
    gameName = Vue.prototype.$projectList.tw.name;
  } else if (Vue.prototype.$isKr) {
    setSessionStorage("lang", "ko-kr");
    app_id = Vue.prototype.$projectList.kr.test_app_id;
    projectId = Vue.prototype.$projectList.kr.test_projectId;
    client_game_app_id = Vue.prototype.$projectList.kr.test_client_game_app_id;
    gameName = Vue.prototype.$projectList.kr.name;
  } else if (Vue.prototype.$isJp) {
    setSessionStorage("lang", "ja-jp");
    app_id = Vue.prototype.$projectList.jp.test_app_id;
    projectId = Vue.prototype.$projectList.jp.test_projectId;
    client_game_app_id = Vue.prototype.$projectList.jp.test_client_game_app_id;
    gameName = Vue.prototype.$projectList.jp.name;
  } else if (Vue.prototype.$isCn) {
    setSessionStorage("lang", "zh-cn");
    app_id = Vue.prototype.$projectList.cn.test_app_id;
    projectId = Vue.prototype.$projectList.cn.test_projectId;
    client_game_app_id = Vue.prototype.$projectList.cn.test_client_game_app_id;
    gameName = Vue.prototype.$projectList.cn.name;
  } else {
    setSessionStorage("lang", "zh-cn");
    app_id = Vue.prototype.$projectList.cn.test_app_id;
    projectId = Vue.prototype.$projectList.cn.test_projectId;
    client_game_app_id = Vue.prototype.$projectList.cn.test_client_game_app_id;
    gameName = Vue.prototype.$projectList.cn.name;
  }
}
Vue.prototype.$appId = app_id;
Vue.prototype.$projectId = projectId;
Vue.prototype.$client_game_app_id = client_game_app_id;
Vue.prototype.$gameName = gameName;
